import { Flex } from "antd";
import { FC } from "react";

import { StyledProductPrice, StyledProductTitle } from "./Styled";

interface ProductHeaderProps {
    name: string;
    barcode: string;
    price: number;
    oldPrice: number;
    isPersonalPrice?: boolean;
}

export const ProductHeader: FC<ProductHeaderProps> = ({
    name,
    barcode,
    price,
    oldPrice,
    isPersonalPrice,
}) => {
    const formattedPrice = price?.toFixed(2) || "---";
    const formattedOldPrice = oldPrice > 0 ? oldPrice.toFixed(2) : "";

    return (
        <Flex justify="space-between">
            <Flex vertical align="flex-start">
                <StyledProductTitle to={`/work-plan/product-card/${barcode}`}>
                    {name}
                </StyledProductTitle>
            </Flex>

            <Flex vertical align="end" style={{ width: "30%" }}>
                <StyledProductPrice $isPersonal={isPersonalPrice}>
                    {formattedPrice} ₴
                </StyledProductPrice>

                {formattedOldPrice && (
                    <StyledProductPrice $isOld={Boolean(formattedOldPrice)}>
                        {formattedOldPrice} ₴
                    </StyledProductPrice>
                )}
            </Flex>
        </Flex>
    );
};
